// 新增模块
import request from '@/utils/request'
import {matchingUrl} from '@/utils/util'
import qs from 'qs'

// 变更模块状态
// 入参：{ "bookId": 题源ID, "type": 模块类型, "status": 修改后的状态 }
export function changeModuleStatus(data) {
  return request({
    url: matchingUrl('/wwqb/home/catalog/status/switch'),
    method: 'post',
    data
  })
}

// 查询模块状态
// 入参：{ bookId 题源id,  catalogType  类型名称 }
export function getModuleStatus(data) {
  // `/wwqb/home/catalog/status/get?bookId=${data.bookId}&catalogType=${data.catalogType}`
  let url = "/wwqb/home/catalog/status/get?"+qs.stringify(data, { encode: false })
  return request({
    url: matchingUrl(url),
    method: 'get'
  })
}

// 变更套卷状态
// 入参：{ id: 套卷id, status: 0启用/1禁用 }
export function changeCoilingStatus(data) {
  return request({
    url: matchingUrl('/wwqb/exam-paper/status/switch'),
    method: 'post',
    data
  })
}

// 发布套卷
// 入参：[...套卷ID]
export function publishCoiling(data) {
  return request({
    url: matchingUrl('/wwqb/exam-paper/publish'),
    method: 'post',
    data
  })
}

// 根据套卷id查询套卷详情
// 入参："id  ": 套卷id
export function getCoilingDetail(id) {
  return request({
    url: `/wwqb/exam-paper/detail?id=${id}`,
    method: 'get'
  })
}

// 批量修改套卷内容
// 入参：[{"id": 1, "content": 试题内容JSON数据 }]
export function modifyCoiling(data) {
  return request({
    url: '/wwqb/exam-paper/content/edit',
    method: 'post',
    data
  })
}

// 批量修改套卷内容 四期，听说精练
// 入参：[{"id": 1, "content": 试题内容JSON数据 }]
export function modifyRefineCoiling(data) {
  return request({
    url: '/stage4/wwqb/exam-paper/content/edit',
    method: 'post',
    data
  })
}

// 根据【题源id+模块类型】查询该模块下的全部套卷
// 入参：{ bookId 题源id,  catalogType  类型名称 }
export function getAllCoiling(data) {
  // `/wwqb/exam-paper/under-catalog/list?bookId=${data.bookId}&catalogType=${data.catalogType}`
  let url = "/wwqb/exam-paper/under-catalog/list?"+qs.stringify(data, { encode: false })
  return request({
    url: matchingUrl(url),
    method: 'get'
  })
}

// 新增一个套卷
// 入参：{ "id": null,可以不传此属性,"bookId": 1,"catalogType": "","name": "" }
export function addCoiling(data) {
  return request({
    url: '/wwqb/exam-paper/add',
    method: 'post',
    data
  })
}

// 新增一个套卷四期
// 入参：{ "id": null,可以不传此属性,"bookId": 1,"catalogType": "","name": "" }
export function addRefiningCoiling(data) {
  return request({
    url: '/stage4/wwqb/exam-paper/add',
    method: 'post',
    data
  })
}

// 根据套卷id删除套卷
// 入参：{ id  套卷id }
export function deleteCoiling(id) {
  return request({
    url: `/wwqb/exam-paper/del?id=${id}`,
    method: 'delete'
  })
}

// 根据id修改套卷名称
// 入参：{ id: 主键id, name: 修改后的名称 }
export function renameCoiling(data) {
  return request({
    url: '/wwqb/exam-paper/rename',
    method: 'post',
    data
  })
}

// 查看听说图书的模块名称是否已存在
export function checkModuleName(data) {
  return request({
    url: `/stage5/wwqb/home/catalog/check?bookId=${data.bookId}&catalogType=${data.catalogType}`,
    method: 'get'
  })
}


// 查询模块列表
export function getModuleList(data) {
  
  return request({
    url: `/stage5/wwqb/home/catalog/selection/get?bookId=${data.bookId}&catalogType=${data.catalogType}`,
    method: 'get'
  })
  // return request({
  //   url: `/stage5/wwqb/home/catalog/combo-box`,
  //   method: 'get'
  // })
}


//收藏列表数据
export function getList(area, type,year,catalogType) {
  let url = `/wwqb/collection/list?area=${area}&year=${year||''}&catalogType=${catalogType||''}`;
  if (type) {
	url = `/wwqb/collection/list?area=${area}&type=${type}&year=${year||''}&catalogType=${catalogType||''}`;
  }
  return request({
    url: url,
    method: 'get'
  })
}

//收藏列表数据
export function getCollectList(area, type) {
  let url = `/stage4/wwqb/collection/list?area=${area}`;
  if (type) {
	url = `/stage4/wwqb/collection/list?area=${area}&type=${type}`;
  }
  return request({
    url: url,
    method: 'get'
  })
}

// 新增收藏
export function addStar(data) {
  return request({
    url: matchingUrl('/wwqb/collection/add'),
    method: 'post',
    data
  })
}

// 收藏重命名
export function reName(id,newName) {
  return request({
    url: `/wwqb/collection/rename?id=${id}&newName=${newName}`,
    method: 'get'
  })
}

//删除收藏
export function deleteStar(id) {
  return request({
    url: matchingUrl(`/wwqb/collection/delete?ids=${id}`),
    method: 'delete'
  })
}

//删除收藏
export function getCollectionStatus(data) {
  return request({
    url: matchingUrl(`/wwqb/collection/getCollectionStatus`),
    method: 'post',
	data
  })
}

// 获取地区下所有套卷
export function getPapersByRegion(regionId) {
  return request({
    url: matchingUrl(`/wwqb/collection/getPapersByRegion?regionId=${regionId}`),
    method: 'get'
  })
}

// 收藏夹插入套卷
export function insertCollections2papers(collectionIds, paperIds) {
  return request({
    url: `/wwqb/collection/insertCollections2papers?collectionIds=${collectionIds}&paperIds=${paperIds}`,
    method: 'get'
  })
}



